/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_UpdatedInputs */

const en_admin_categories_updated = /** @type {(inputs: Admin_Categories_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category updated`)
};

/**
* | output |
* | --- |
* | "Category updated" |
*
* @param {Admin_Categories_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_updated = /** @type {((inputs?: Admin_Categories_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_updated(inputs)
});
export { admin_categories_updated as "admin.categories.updated" }